var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnoyance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 14C23.0011 16.0413 22.3052 18.0218 21.0275 19.6138L8.38626 6.9725C9.70942 5.91346 11.3049 5.24983 12.9888 5.0581C14.6727 4.86638 16.3766 5.15435 17.9039 5.88884C19.4313 6.62333 20.7201 7.77444 21.6217 9.20951C22.5233 10.6446 23.0011 12.3052 23 14ZM5.00001 14C4.9989 15.6948 5.47669 17.3554 6.37831 18.7905C7.27993 20.2256 8.56869 21.3767 10.0961 22.1112C11.6234 22.8457 13.3273 23.1336 15.0112 22.9419C16.6951 22.7502 18.2906 22.0865 19.6138 21.0275L6.97251 8.38625C5.69482 9.97822 4.99893 11.9587 5.00001 14ZM27.5 14C27.5 16.67 26.7082 19.2801 25.2248 21.5002C23.7414 23.7203 21.633 25.4506 19.1662 26.4724C16.6994 27.4942 13.985 27.7615 11.3663 27.2406C8.74754 26.7197 6.34207 25.434 4.45406 23.5459C2.56606 21.6579 1.28031 19.2525 0.759405 16.6337C0.238504 14.015 0.505849 11.3006 1.52763 8.83377C2.54942 6.36697 4.27974 4.25856 6.49981 2.77516C8.71987 1.29176 11.33 0.5 14 0.5C17.5792 0.50397 21.0107 1.92756 23.5416 4.45844C26.0724 6.98932 27.496 10.4208 27.5 14ZM25 14C25 11.8244 24.3549 9.69767 23.1462 7.88873C21.9375 6.07979 20.2195 4.66989 18.2095 3.83733C16.1995 3.00476 13.9878 2.78692 11.854 3.21136C9.72022 3.6358 7.76021 4.68345 6.22183 6.22183C4.68345 7.7602 3.63581 9.72022 3.21137 11.854C2.78693 13.9878 3.00477 16.1995 3.83733 18.2095C4.6699 20.2195 6.07979 21.9375 7.88873 23.1462C9.69767 24.3549 11.8244 25 14 25C16.9164 24.9967 19.7123 23.8367 21.7745 21.7745C23.8367 19.7123 24.9967 16.9164 25 14Z",
    fill: "url(#paint0_linear_668_21146)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_21146",
    x1: 0.5,
    y1: 27.5,
    x2: 32.8045,
    y2: 10.6997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6347"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnoyance);
export default __webpack_public_path__ + "static/media/Annoyance.763ade0c432dece5db3e22a8136e7c48.svg";
export { ForwardRef as ReactComponent };